export default __webpack_public_path__ + "static/media/share.cc843c7f.svg";